module.exports = __webpack_public_path__ + "img/img_wait.99266837.png";